import React from 'react';
import { Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Button,  Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Link, NavLink as RouterNavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import Slider from "react-slick";
import axios from 'axios'
import { auth } from '../../../../../../services';
import { ROOT_API_URL } from "../../../../../../api-config";
import { LoginMenu } from '../../../../Authentication/LoginMenu/LoginMenu';
import { store } from '../../../../../../services/store.service';
import { getCartItems } from '../../../../../../Redux/Actions/EndUser/StoreActions';
import { withRouter } from 'react-router';

class StoreNav extends React.Component {
	constructor(props) {
		super(props);
        this.state = {
            storeCategories: null,
		    isOpen: false,
            modalIsOpen: false,
            cartItems:[]
		};
		this.toggle = this.toggle.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
    }

    componentDidMount = () => {
        axios.get(`${ROOT_API_URL}/Lookup/GetProductTypes`)
        .then(res => {
            this.setState({
                storeCategories: res.data
            })
        });

        this.setState({
            cartItems:store.getSelectedProducts()
        },()=>{
            this.props.getCartItems()
        })

    }
  
	toggle() {
	  this.setState({ isOpen: !this.state.isOpen });
	}

	toggleModal() {
		this.setState({
		  modalIsOpen: !this.state.modalIsOpen
		});
	}

	navItemTrigger() {
		if(this.state.isOpen) {
			this.toggle();
		}
	}

    GetNav() {
        var settings = {
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            speed: 500,
            autoplaySpeed: 5000,
            cssEase: "linear",
            pauseOnHover: true
        };
		return (
            <header className="storeNav">

                <div className="storeSlider">
                    <Slider {...settings}>
                        <div className="storeSingleSlider cols">
                            <div className="col-left"></div>
                            <div className="col-right">
                                <h3 className="storeSliderTitle">Welcome</h3>
                                <p className="storeSliderText">We hope you enjoy our selection of merchandise at Cattle Raisers Trading Co.! Show off your TSCRA pride and outfit your family right! </p>
                                <p className="storeSliderSocial">
                                    <span>Follow us on social media for special discounts/incentives!</span>
                                    <span className="social">
                                        <a href="https://www.facebook.com/tscra/posts/want-to-show-off-your-tscra-pride-visit-cattle-raisers-trading-co-for-a-new-sele/450631218289378/" target="_blank"><img className="social-icons" src="/images/fb.png" alt="facebook icon" /></a>
                                        <a href="https://twitter.com/tscra?lang=en" target="_blank"><img className="social-icons" src="/images/tw.png" alt="twitter icon" /></a>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </Slider>
                </div>
				<div>
					<Navbar light expand="lg" className="container">
						<NavbarToggler onClick={this.toggle} />
						<Collapse isOpen={this.state.isOpen} navbar>
                            <Nav className="mr-auto" navbar>
                                <NavItem onClick={() => { this.navItemTrigger() }} >
                                    <NavLink tag={RouterNavLink}
                                        className={this.props.location.pathname === "/store/" || this.props.location.pathname === "/store" ? 'active-navlink' : 'notActive'}
                                        to={"/store/"}>
                                        All
                                    </NavLink>
                                </NavItem>
                                {this.state.storeCategories ?
                                    this.state.storeCategories.map((category, index) => {
                                        return (
                                            <NavItem onClick={() => { this.navItemTrigger() }} key={index} >
                                                <NavLink tag={RouterNavLink}
                                                    className={this.props.location.pathname === "/store/" + category.name ? 'active-navlink' : ''}
                                                    to={"/store/" + category.name + "?categoryId=" + category.id}>
                                                    {category.name}
									            </NavLink>
                                            </NavItem>
                                        )
                                    }) : null
                                }
                            </Nav>
                        </Collapse>
                        <div className="storeBtn">
                            <Link 
                                to={"/shoppingcart/"}>
                                {this.props.store.cartTotal} Cart
                            </Link>
                        </div>
					</Navbar>
					<Modal isOpen={this.state.modalIsOpen} toggle={this.toggleModal} className={this.props.className}>
						<ModalHeader toggle={this.toggleModal}>Login</ModalHeader>
                        <ModalBody>
                            <LoginMenu toggle={this.toggleModal} />
						</ModalBody>
        			</Modal>
                </div>
			</header>
		);
	}

	GetLoginMenu() {
		return (
			<Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={this.state.isOpen} navbar>
				<LoginMenu />
			</Collapse>
		);
	}

	render() {
        let nav = this.GetNav();
        return <div> {nav} </div>;
        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };
	}
}

function mapStateToProps(state) {
    return {
        store: state.store
    }
}

export default withRouter(connect(mapStateToProps, { getCartItems })(StoreNav));